import React, { useContext } from 'react';

export const RootPropsContext = React.createContext({});

export const RootPropsProvider = RootPropsContext.Provider;

export const useRootProps = () => {
  return useContext(RootPropsContext);
};
